import { render, staticRenderFns } from "./ConferenceForm.vue?vue&type=template&id=4aa30a2e&"
import script from "./ConferenceForm.vue?vue&type=script&lang=js&"
export * from "./ConferenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports